import { SET_CALC_AFECTO } from '../actionTypes/percentil'

export const setCalcAfecto = (obj) => {
  // console.log(obj)
  let {
    preocupacion,
    contento,
    tranquilo,
    desanimo,
    optimista,
    satisfecho,
    irritable,
    decepcionado
  } = obj
  let res1 = (preocupacion + irritable) / 2
  let res2 = (contento + optimista) / 2
  let res3 = (tranquilo + satisfecho) / 2
  let res4 = (desanimo + decepcionado) / 2
  let val11 = (res2 + res3) / 2
  let val21 = (res1 + res4) / 2
  let val12 = (res1 + res2)
  let val22 = res4 + res3
  const afectoX = +val11 - val21
  const afectoY = -val22 + val12
  const bienestar = (val11/(val21 +val11))*100
  const malestar = (val21/(val21 +val11))*100
  // console.log(afectoX, afectoY)
  return {
    type: SET_CALC_AFECTO,
    payload: {
      preocupacion: preocupacion,
      contento: contento,
      tranquilo: tranquilo,
      desanimo: desanimo,
      optimista: optimista,
      satisfecho: satisfecho,
      irritable: irritable,
      decepcionado: decepcionado,
      bienestar,
      malestar,
      afectoX,
      afectoY
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/percentil.js